import { YoutubeSearchTool } from './containers';
import reducer from './redux/reducer';

const YoutubeSearch = {
  reducer,
  bodyComponent: YoutubeSearchTool,
};

export default YoutubeSearch;
